export enum FillDatesDialogModeEnum {
    Unset = 0,
    FillDates = 1,
    UpdateOrDeleteClosedDatesEvent = 2,
}
